import * as React from "react";

interface GuessedIconProps {}

export const GuessedIcon: React.FC<GuessedIconProps> = () => (
  <svg height="112px" width="112px" viewBox="0 0 496 512">
    <path
      fill="currentColor"
      d="M248 8a248 248 0 100 496 248 248 0 000-496zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216a32 32 0 100-64 32 32 0 000 64zm160 0a32 32 0 100-64 32 32 0 000 64zm4 72.6a109.1 109.1 0 01-168 0 24 24 0 00-33.8-3.1 24 24 0 00-3.1 33.8c30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6a24 24 0 10-36.9-30.7z"
    />
  </svg>
);
